import {
  Avatar,
  Button,
  Card,
  CardBody,
  Chip,
  Input,
  ModalBody,
  ModalHeader,
  useDisclosure,
  NextUIProvider,
} from "@nextui-org/react";
import React, { useEffect, useRef, useState } from "react";
import {
  DeleteOnedata,
  UpdateOneData,
  getOnedata,
  uploadFile,
} from "../../controllers/APIController";
import ModalPopup from "../../components/ModalPopup";
import DeleteModal from "../../components/DeleteModal";
import { useNavigate } from "react-router-dom";
import { Switch } from "@nextui-org/react";
import LoadingPage from "../../components/Loader/LoadingPage";
const Profile = () => {
  const [UserDetails, setUserDetails] = useState(null);
  const [Loader, setLoader] = useState(true);
  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const UserId = UserLogged && UserLogged.user.id;
  const fileInputRef = useRef();
  const [showInput, setShowInput] = useState(false);
  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onOpenChange: onModalOpenChange,
  } = useDisclosure();
  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onOpenChange: onDeleteOpenChange,
  } = useDisclosure();
  const [FileUpload, setFileUpload] = useState(null);
  const [fileUploaded, setFileUploaded] = useState();
  const [Response, setResponse] = useState("");
  const Navigate = useNavigate();
  // const [Theme, setTheme] = useState(null);

  const [formData, setFormData] = useState({
    FirstName: "",
    LastName: "",
    ProfilePicture: "",
    // Theme: '',
  });

  useEffect(() => {
    setLoader(true);
    getOnedata("users", UserId).then((data) => {
      setLoader(false);

      setFormData({
        FirstName: data?.FirstName,
        LastName: data?.LastName,
        ProfilePicture:
          data && data?.ProfilePictureUrl !== null && data?.ProfilePictureUrl,
        // Theme: data && data.Theme
      });
      setUserDetails(data);
    });
  }, [Response, UserId]);

  const UploadFileHandler = async () => {
    if (!FileUpload) return;
    setLoader(true);

    let formData = new FormData();
    formData.append("uploaded_file", FileUpload);
    const response = await uploadFile(formData);
    if (response) {
      setLoader(false);
      const URLresponse = response && response[0];
      URLresponse && setFileUploaded(URLresponse);
    }
  };

  useEffect(() => {
    UploadFileHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [FileUpload]);

  const UserProfile =
    UserDetails && UserDetails.ProfilePictureUrl !== null
      ? UserDetails.ProfilePictureUrl
      : "";
  const UploadedUser =
    fileUploaded && fileUploaded !== null && `${fileUploaded.url}`;

  const UpdateProfile = async (onClose) => {
    setLoader(true);
    const payload = {
      FirstName: formData.FirstName,
      LastName: formData.LastName,
      ProfilePictureUrl: fileUploaded?.url,
      // Theme: formData.Theme
    };

    const response = await UpdateOneData("users", UserId, payload);
    if (response) {
      onClose();
      setLoader(false);
      setResponse(response);
    }
  };

  const handleFileChange = (event) => {
    const files = event.target.files;

    if (files && files[0]) {
      const file = files[0];
      setFileUpload(file);
    } else {
      setFileUpload(null);
    }
  };

  const Handleremove = async () => {
    setFileUploaded(null);
    setFormData({ ...formData, ProfilePicture: "" });
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const DeleteHandler = async () => {
    setLoader(true);
    const response = await DeleteOnedata("users", UserId);
    if (response) {
      setLoader(false);
      Navigate("/sign-in");
      sessionStorage.clear();
    }
  };

  // const HandleThemeChange = async (e) => {

  //   console.log("e.anchorKey", e.anchorKey)
  //   console.log("UserDetails.Theme", UserDetails.Theme)
  //   setFormData({ ...formData, Theme: e.anchorKey === "undefined" ? UserDetails.Theme : e.anchorKey });

  //   let payload = {
  //     Theme: e.anchorKey
  //   }
  //   const response = await UpdateOneUserData("users", UserId, payload);
  //   if (response) {
  //     setLoader(false);
  //     setResponse(response);
  //     console.log("response", response)

  //   }
  // }

  const Colors = ["secondary", "success", "warning", "danger", "primary"];

  const numColors = Colors.length;
  const colorIndex = UserDetails && UserDetails.id % numColors;

  const ModalBodyData = () => {
    return (
      <>
        <ModalHeader>Edit profile</ModalHeader>
        <ModalBody>
          <div className="flex flex-row items-center gap-6">
            <Avatar
              radius="full"
              size="lg"
              src={UploadedUser ? UploadedUser : formData.ProfilePicture}
              color={Colors[colorIndex]}
              name={
                UserDetails && UserDetails.FirstName !== null
                  ? UserDetails &&
                    UserDetails.FirstName.slice(0, 1).toUpperCase()
                  : UserDetails && UserDetails.email.slice(0, 1).toUpperCase()
              }
            />
            <input
              ref={fileInputRef}
              type="file"
              onChange={(event) => handleFileChange(event)}
              className="hidden"
            />
            <Button onClick={handleButtonClick} size="sm" variant="bordered" aria-label="Select profile image">
              Select profile image
            </Button>
            {UserProfile ? (
              <p className="text-xs cursor-pointer" onClick={Handleremove}>
                Remove
              </p>
            ) : (
              ""
            )}
          </div>
          <div className="flex flex-col gap-4 pt-4">
            <div>
              <p className="text-sm font-normal text-neutral-500 pb-1">
                First name
              </p>
              <Input
                key="outside"
                type="text"
                size="sm"
                label=""
                defaultValue={formData && formData.FirstName}
                onChange={(e) =>
                  setFormData({ ...formData, FirstName: e.target.value })
                }
                labelPlacement="outside"
                placeholder="Enter your full name"
              />
            </div>
            <div>
              <p className="text-sm font-normal text-neutral-500 pb-1">
                Last name
              </p>
              <Input
                key="outside"
                type="text"
                size="sm"
                label=""
                defaultValue={formData && formData.LastName}
                onChange={(e) =>
                  setFormData({ ...formData, LastName: e.target.value })
                }
                labelPlacement="outside"
                placeholder="Enter your last name"
              />
            </div>
            <div className="cursor-not-allowed">
              <p className="text-sm font-normal text-neutral-500 pb-1">Email</p>
              <Input
                isDisabled
                key="outside"
                type="text"
                size="sm"
                label=""
                value={UserDetails && UserDetails.email}
                labelPlacement="outside"
                placeholder="Enter your email"
              />
            </div>
          </div>
        </ModalBody>
      </>
    );
  };

  const footerCreate = (onClose) => {
    return (
      <>
        <Button 
          color="primary" 
          className="bg-primary-600 hover:bg-primary-700 text-white px-6 font-medium"
          onClick={() => UpdateProfile(onClose)}
        >
          Update
        </Button>
      </>
    );
  };

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Page Header */}
      <div className="bg-white border-b border-neutral-200 px-8 py-4 shadow-sm">
        <div className="flex items-center justify-between max-w-full">
          <div>
            <h1 className="text-xl font-semibold text-neutral-900">Profile Settings</h1>
            <p className="text-xs text-neutral-600 mt-1">Manage your account information and preferences</p>
          </div>
          <div className="flex items-center gap-3">
            <Button
              color="primary"
              size="sm"
              className="bg-primary-600 hover:bg-primary-700 text-white px-6 font-medium text-xs"
              onPress={onModalOpen}
            >
              Edit Profile
            </Button>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-8 py-4">
        <LoadingPage isLoading={Loader}>
          <NextUIProvider>
            {/* Profile Card */}
            <div className="bg-white rounded-lg border border-neutral-200 shadow-sm p-6 mb-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-lg font-semibold text-neutral-900">Personal Information</h2>
                <Chip color="primary" variant="flat" size="sm">
                  Active User
                </Chip>
              </div>
              
              {/* Avatar and Name Section */}
              <div className="flex items-center gap-6 mb-8">
                <Avatar
                  radius="full"
                  size="lg"
                  className="w-20 h-20"
                  color={Colors[colorIndex]}
                  src={UserProfile}
                  name={
                    UserDetails && UserDetails.FirstName !== null
                      ? UserDetails &&
                        UserDetails.FirstName.slice(0, 1).toUpperCase()
                      : UserDetails &&
                        UserDetails.email.slice(0, 1).toUpperCase()
                  }
                />
                <div className="flex flex-col">
                  <h3 className="text-xl font-semibold text-neutral-900">
                    {UserDetails && UserDetails.FirstName !== null
                      ? `${UserDetails.FirstName} ${UserDetails.LastName}`
                      : UserDetails && UserDetails.email}
                  </h3>
                  <p className="text-sm text-neutral-600">
                    {UserDetails && UserDetails.email !== null
                      ? UserDetails.email
                      : ""}
                  </p>
                </div>
              </div>

              {/* Profile Details */}
              <div className="space-y-4">
                <div className="flex items-center justify-between py-3 border-b border-neutral-100">
                  <span className="text-sm font-medium text-neutral-600">Display Name</span>
                  <span className="text-sm text-neutral-900">
                    {UserDetails &&
                    (UserDetails.FirstName !== null ||
                      UserDetails.LastName !== null)
                      ? UserDetails &&
                        `${
                          UserDetails.FirstName !== null
                            ? UserDetails.FirstName
                            : ""
                        } ${
                          UserDetails.LastName !== null
                            ? UserDetails.LastName
                            : ""
                        }`
                      : ""}
                  </span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-neutral-100">
                  <span className="text-sm font-medium text-neutral-600">Email</span>
                  <span className="text-sm text-neutral-900">
                    {UserDetails && UserDetails.email !== null
                      ? UserDetails.email
                      : ""}
                  </span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-neutral-100">
                  <span className="text-sm font-medium text-neutral-600">Role</span>
                  <Chip size="sm" variant="flat" color="success" className="text-xs">
                    Admin
                  </Chip>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-neutral-100">
                  <span className="text-sm font-medium text-neutral-600">User Since</span>
                  <span className="text-sm text-neutral-900">19 June 2024</span>
                </div>
                <div className="flex items-center justify-between py-3">
                  <span className="text-sm font-medium text-neutral-600">Last Login</span>
                  <span className="text-sm text-neutral-900">2 hr ago</span>
                </div>
              </div>
            </div>
          </NextUIProvider>

          <NextUIProvider>
            {/* Notifications Card */}
            <div className="bg-white rounded-lg border border-neutral-200 shadow-sm p-6 mb-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-lg font-semibold text-neutral-900">Notification Settings</h2>
                <Chip color="warning" variant="flat" size="sm">
                  Configured
                </Chip>
              </div>
              <p className="text-sm text-neutral-600 mb-6">
                Enable notifications to get notified about your activities through Slack, Teams, Discord and email.
              </p>
              
              <div className="space-y-6">
                {/* Slack */}
                <div className="flex items-center justify-between p-4 border border-neutral-100 rounded-lg">
                  <div className="flex flex-col gap-1">
                    <p className="text-sm font-medium text-neutral-900">Slack</p>
                    <p className="text-xs text-neutral-500">
                      Get notified through Slack
                    </p>
                  </div>
                  <Switch
                    color="success"
                    size="sm"
                    checked={showInput}
                    onChange={(checked) => setShowInput(checked)}
                  />
                </div>
                
                {showInput && (
                  <div className="p-4 bg-neutral-50 rounded-lg border border-neutral-200">
                    <Input
                      type="text"
                      radius="sm"
                      size="sm"
                      className="max-w-md"
                      labelPlacement="outside"
                      placeholder="Add your slack channel URL"
                      label="Slack channel"
                    />
                  </div>
                )}

                {/* Teams */}
                <div className="flex items-center justify-between p-4 border border-neutral-100 rounded-lg">
                  <div className="flex flex-col gap-1">
                    <p className="text-sm font-medium text-neutral-900">Teams</p>
                    <p className="text-xs text-neutral-500">
                      Get notified through Teams
                    </p>
                  </div>
                  <Switch color="success" size="sm" />
                </div>

                {/* Discord */}
                <div className="flex items-center justify-between p-4 border border-neutral-100 rounded-lg">
                  <div className="flex flex-col gap-1">
                    <p className="text-sm font-medium text-neutral-900">Discord</p>
                    <p className="text-xs text-neutral-500">
                      Get notified through Discord
                    </p>
                  </div>
                  <Switch color="success" size="sm" />
                </div>

                {/* Email */}
                <div className="flex items-center justify-between p-4 border border-neutral-100 rounded-lg">
                  <div className="flex flex-col gap-1">
                    <p className="text-sm font-medium text-neutral-900">Email</p>
                    <p className="text-xs text-neutral-500">
                      Get notified through email
                    </p>
                  </div>
                  <Switch color="success" size="sm" defaultSelected />
                </div>
              </div>
            </div>
          </NextUIProvider>
          
          <NextUIProvider>
            {/* Danger Zone Card */}
            <div className="bg-white rounded-lg border border-red-200 shadow-sm p-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-lg font-semibold text-red-900">Danger Zone</h2>
                <Chip color="danger" variant="flat" size="sm">
                  Irreversible
                </Chip>
              </div>
              <p className="text-sm text-error-600 mb-6">
                This will permanently remove your account and you will lose access to all your data.
              </p>
              <div className="flex items-center justify-between p-4 bg-red-50 border border-red-200 rounded-lg">
                <div className="flex flex-col gap-1">
                  <p className="text-sm font-medium text-red-900">Delete Account</p>
                  <p className="text-xs text-error-600">
                    Permanently delete your account and all associated data
                  </p>
                </div>
                <Button
                  size="sm"
                  onPress={onDeleteOpen}
                  className="bg-error-600 hover:bg-error-700 text-white px-6 font-medium text-xs"
                >
                  Delete Account
                </Button>
              </div>
            </div>
          </NextUIProvider>
        </LoadingPage>
      </div>

      <ModalPopup
        isOpen={isModalOpen}
        onOpenChange={onModalOpenChange}
        ModalBodyData={ModalBodyData}
        footer={footerCreate}
      />

      <DeleteModal
        isOpen={isDeleteOpen}
        onOpenChange={onDeleteOpenChange}
        deleteData={""}
        setDeleteData={""}
        Collectionname={"user"}
        setLoader={setLoader}
        DeleteHandler={DeleteHandler}
      />
    </div>
  );
};

export default Profile;
